export default __webpack_public_path__ + "static/media/ding.193420e4.mp3";